import { Component, OnDestroy, OnInit, inject, input } from '@angular/core';
import { BoDialogComponent } from '@3ddv/software-division-components/backoffice/dialog';
import { ButtonComponent } from '@3ddv/software-division-components/generic/button';
import { BrnDialogRef } from '@spartan-ng/brain/dialog';
import { Subscription } from 'rxjs';
import { LoaderService } from '../../../../core/services/loader.service';
import { DialogCloseReason } from '../../../layout/dialog/app-dialog.service';
import { GroupLink } from '../../models/group-links.model';
import { GroupLinkService } from '../../services/group-links.service';

@Component({
  selector: 'app-delete',
  templateUrl: './delete.component.html',
  styleUrls: ['./delete.component.css'],
  imports: [BoDialogComponent, ButtonComponent],
})
export class DeleteComponent implements OnInit, OnDestroy {
  private dialogRef = inject<BrnDialogRef<DialogCloseReason>>(BrnDialogRef);
  private groupLinkService = inject(GroupLinkService);
  private loader = inject(LoaderService);

  readonly id = input.required<number | string>();

  public data: GroupLink;
  private subscriptions: Array<Subscription>;
  constructor() {
    this.subscriptions = [];
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(o => o.unsubscribe());
  }

  ngOnInit(): void {
    let id = this.id();
    if (typeof id === 'string') {
      id = parseInt(id);
    }
    if (typeof id === 'number') {
      const g$ = this.loader.track(this.groupLinkService.get$(id)).subscribe({
        next: response => {
          this.data = response.data;
        },
        error: err => {
          console.log(err);
        },
      });
      this.subscriptions.push(g$);
    }
  }

  public onDismiss(reason: DialogCloseReason) {
    this.dialogRef.close(reason);
  }

  public onConfirm(id: number) {
    this.groupLinkService.delete$(id).subscribe({
      next: response => {
        this.onDismiss('success');
      },
      error: err => {
        console.log(err);
      },
    });
  }
}
